import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface MobileVerificationState {
    selectedCountry: string;
    countryField: string;
    mobileNumber: string;
    smsTriggered: boolean;
    disableResendOtp: boolean;
    resendTimer: number;
    error: boolean;
    otp: string[];
    resendAttempt: number;
    verifyAttempt: number;
    otpVerified: boolean;
    options: any[];
    disableBtn: boolean;
    lastSentType: string;
    phoneExistsError: boolean;
    otpError: boolean;
    mobileUnverifiedUser: boolean;
    showModalRequest?: boolean;
    isModalOpen?: boolean;
    verificationStatusLoaded?: boolean;
}

const initialState: MobileVerificationState = {
    selectedCountry: "+91",
    countryField: "+91",
    mobileNumber: "",
    smsTriggered: false,
    disableResendOtp: false,
    resendTimer: 30,
    error: false,
    otp: new Array(6).fill(""),
    resendAttempt: 0,
    verifyAttempt: 0,
    otpVerified: false,
    options: [],
    disableBtn: false,
    lastSentType: "sms",
    phoneExistsError: false,
    otpError: false,
    mobileUnverifiedUser: true,
    showModalRequest: false,
    isModalOpen: false,
    verificationStatusLoaded: false
};


const mobileVerificationSlice = createSlice({
    name: "mobileVerification",
    initialState,
    reducers: {
        setSelectedCountry: (state, action: PayloadAction<string>) => {
            state.selectedCountry = action.payload;
        },
        setCountryField: (state, action: PayloadAction<string>) => {
            state.countryField = action.payload;
        },
        setMobileNumber: (state, action: PayloadAction<string>) => {
            state.mobileNumber = action.payload;
        },
        setSmsTriggered: (state, action: PayloadAction<boolean>) => {
            state.smsTriggered = action.payload;
        },
        setDisableResendOtp: (state, action: PayloadAction<boolean>) => {
            state.disableResendOtp = action.payload;
        },
        setResendTimer: (state, action: PayloadAction<number>) => {
            state.resendTimer = action.payload;
        },
        setError: (state, action: PayloadAction<boolean>) => {
            state.error = action.payload;
        },
        setOtp: (state, action: PayloadAction<string[]>) => {
            state.otp = action.payload;
        },
        setResendAttempt: (state, action: PayloadAction<number>) => {
            state.resendAttempt = action.payload;
        },
        setVerifyAttempt: (state, action: PayloadAction<number>) => {
            state.verifyAttempt = action.payload;
        },
        setOtpVerified: (state, action: PayloadAction<boolean>) => {
            state.otpVerified = action.payload;
        },
        setOptions: (state, action: PayloadAction<any[]>) => {
            state.options = action.payload;
        },
        setDisableBtn: (state, action: PayloadAction<boolean>) => {
            state.disableBtn = action.payload;
        },
        setLastSentType: (state, action) => {
            state.lastSentType = action.payload;
        },
        setPhoneExistsError: (state, action) => {
            state.phoneExistsError = action.payload;
        },
        setotpError: (state, action) => {
            state.otpError = action.payload;
        },
        setShowModalRequest: (state, action) => {
            state.showModalRequest = action.payload;
        },
        setMobileUnverifiedUser: (state, action) => {
            state.mobileUnverifiedUser = action.payload;
        },
        setVerificationStatusLoaded: (state, action: PayloadAction<boolean>) => {
            state.verificationStatusLoaded = action.payload;
        },
        setisModalOpen: (state, action: PayloadAction<boolean>) => {
            state.isModalOpen = action.payload;
        },
        resetMobileStoreState: () => initialState,
    },
});

export const {
    setSelectedCountry,
    setCountryField,
    setMobileNumber,
    setSmsTriggered,
    setDisableResendOtp,
    setResendTimer,
    setError,
    setOtp,
    setResendAttempt,
    setVerifyAttempt,
    setOtpVerified,
    setOptions,
    setDisableBtn,
    resetMobileStoreState,
    setLastSentType,
    setPhoneExistsError,
    setotpError,
    setMobileUnverifiedUser,
    setShowModalRequest,
    setVerificationStatusLoaded,
    setisModalOpen
} = mobileVerificationSlice.actions;

export default mobileVerificationSlice.reducer;
